import { render, staticRenderFns } from "./ProductFacets.vue?vue&type=template&id=4b06464e"
import script from "./ProductFacets.vue?vue&type=script&lang=ts"
export * from "./ProductFacets.vue?vue&type=script&lang=ts"
import style0 from "./ProductFacets.vue?vue&type=style&index=0&id=4b06464e&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports